const zoomMap = 14;

const talhaoMapColor = "rgba(40,177,20,0.3)";
const heatmapBackground = "rgb(40,177,20,0.2)";
const heatmapTalhao = "rgb(255,255,255,0.5)";
export { zoomMap, talhaoMapColor, heatmapBackground, heatmapTalhao };
